import imageCompression from "browser-image-compression";

async function ImageCompressor(imageFile, maxSizeMB = 0.2) {
    const options = {
        maxSizeMB,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
        fileType: imageFile.type || "image/jpeg",
    };

    const compressedImageBlob = await imageCompression(imageFile, options);

    // Convert Blob back to File
    const compressedFile = new File([compressedImageBlob], imageFile.name, {
        type: compressedImageBlob.type,
        lastModified: Date.now(),
    });

    // console.log("Original size:", (imageFile.size / 1024 / 1024).toFixed(2), "MB");
    // console.log("Compressed size:", (compressedFile.size / 1024 / 1024).toFixed(2), "MB");

    return compressedFile;
}

export default ImageCompressor;
